export const REDUCER_KEY = 'works';
export const SET_WORKS = 'SET_WORKS';
export const SET_WORKS_COMPOSERS = 'SET_WORKS_COMPOSERS';
export const SET_INDEX_ROOT_CATEGORY = 'SET_INDEX_ROOT_CATEGORY';
export const SET_INDEX_WORKS_COMPOSERS_CATEGORY = 'SET_INDEX_WORKS_COMPOSERS_CATEGORY';
export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME';
export const SET_FAMOUS_FILTER = 'SET_FAMOUS_FILTER';
export const SET_PERFORMANCES = 'SET_PERFORMANCES';
export const SET_LANG_WORKS = 'SET_LANG_WORKS';
export const SET_WORKS_DEFAULTS = 'SET_WORKS_DEFAULTS';